import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';

import { NgbActiveModal, NgbModalRef, NgbDateStruct, NgbTimeStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, DateUtils } from 'ng-jhipster';

import { School, SchoolService } from '../school';
import { Student, StudentService, StudentTypeaheadService } from '../student';
import { Location, LocationService } from '../location';
import { Principal, CRUD_ACTIONS, DateUtilities } from '../../shared';
import { EventPopupService } from './event-popup.service';
import { Event } from './event.model';
import { EventService } from './event.service';
import { AbstractDialogComponent } from '../abstract-dialog-component/abstract-dialog.component';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

import { SERVER_DATE_TIME_FORMAT } from '../../shared/constants/date-time.constants';



@Component({
    selector: 'jhi-event-dialog',
    templateUrl: './event-dialog.component.html'
})
export class EventDialogComponent extends AbstractDialogComponent implements OnInit {

    event: Event;
    school: School;
    locations: Location[];

    eventFromDate: NgbDateStruct;
    eventStartTime: NgbTimeStruct;

    eventEndTime: NgbTimeStruct;
    eventToDate: NgbDateStruct;

    isSaving: boolean;

    // typeahead for the Facilitator
    search = this.studentTypeaheadService.search;

    resultFormatter = this.studentTypeaheadService.resultFormatter;

    inputFormatter = (facilitator: any) => this.studentTypeaheadService.inputFormatter(facilitator, () => this.event.facilitator['user']);

    constructor(
            public activeModal: NgbActiveModal,
            alertService: AlertService,
            schoolService: SchoolService,
            private studentTypeaheadService: StudentTypeaheadService,
            private locationService: LocationService,
            private eventService: EventService,
            private eventManager: EventManager,
            private dateUtils: DateUtils,
            private datePipe: DatePipe,
            principal: Principal,
            private router: Router
    ) {
        super(schoolService, alertService, principal);
    }

    ngOnInit(): void {
        this.isSaving = false;

        this.eventFromDate = DateUtilities.toDateStruct(this.event.begining);
        this.eventStartTime = DateUtilities.toTimeStruct(this.event.begining);
        this.eventEndTime = DateUtilities.toTimeStruct(this.event.ending);
        this.eventToDate = DateUtilities.toDateStruct(this.event.ending);

        this.locationService.search({query: 'active:true'})
            .subscribe(
            (res: HttpResponse<Location[]>) => {
                this.locations = res.body;
            }, (res: HttpErrorResponse) => this.onError(res));

         this.schoolService
            .findCurrent()
            .subscribe( (s: School) => {
                this.school = s;
            }, (e: HttpErrorResponse) =>this.onError(e) );
    }

    save(form: NgForm) {
        // validate the facilitator text field
        let facilitator: any = this.event.facilitator;
        let facilitatorInput = form !== undefined ? form.controls['facilitator'] : null;
        let facilitatorInputValue = facilitatorInput && facilitatorInput.value ? facilitatorInput.value : null;

        if (!facilitator && (facilitatorInputValue === null || facilitatorInputValue.trim().length === 0)) {
            // We nullify the facilitator cause the input is empty
            this.event.facilitator = null;
        } else if (facilitatorInput.dirty && !facilitator.user && !facilitator.userId)  {
            // We reset the input cause it does not have a facilitator but a non empty string
            facilitatorInput.reset();
            return;
        }

        let begining: Date = new Date();
        begining.setDate(this.eventFromDate.day);
        begining.setMonth(this.eventFromDate.month - 1);
        begining.setFullYear(this.eventFromDate.year);
        begining.setHours(this.eventStartTime.hour);
        begining.setMinutes(this.eventStartTime.minute);
        this.event.begining = this.datePipe
        .transform(begining, SERVER_DATE_TIME_FORMAT);

        let ending: Date = new Date();
        ending.setDate(this.eventToDate.day);
        ending.setMonth(this.eventToDate.month - 1 );
        ending.setFullYear(this.eventToDate.year);
        ending.setHours(this.eventEndTime.hour);
        ending.setMinutes(this.eventEndTime.minute);
        this.event.ending = this.datePipe
        .transform(ending, SERVER_DATE_TIME_FORMAT);

        this.isSaving = true;
        if (this.event.id !== undefined) {
            this.event.begining = this.dateUtils.toDate(this.event.begining);
            this.event.ending = this.dateUtils.toDate(this.event.ending);
            this.eventService.update(this.event)
            .subscribe((res: Event) =>
                this.onSaveSuccess(res, CRUD_ACTIONS.UPDATE), (res: HttpErrorResponse) => this.onSaveError(res));
        } else {
            this.eventService.create(this.event)
                .subscribe((res: Event) =>
                    this.onSaveSuccess(res, CRUD_ACTIONS.CREATE), (res: HttpErrorResponse) => this.onSaveError(res));
        }

    }

    private onSaveSuccess(result: Event, action: String) {
        if (action === CRUD_ACTIONS.CREATE) {
            this.router.navigateByUrl('/event/' + result['id'], { replaceUrl: true });
        } else {
            this.eventManager.broadcast({ name: 'eventListModification', content: {
                action: action,
                content: result
            }});
        }
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        this.isSaving = false;
        this.onError(error);
    }

    onAcceptOnlinePaymentsChange(value: boolean): void {
        this.event.acceptOnlinePayments = value;

        if (!value) {
            this.event.backOfficeUnitPriceId = null;
        }
    }

    onPriceChange(price: number): void {
        this.event.standardUnitPrice = price;
        this.event.free = price === 0;
    }

    hideOnlinePaymentSection () {
        return !this.school ||
                !this.school.acceptOnlinePayments ||
                !this.school.onlinePaymentsModuleEnabled ||
                !this.school.backofficeAccountId;
    }

    onVideoConferenceChange(value: boolean): void {
        this.event.videoConference = value;

        if (!value) {
            this.event.videoConferenceUrl = null;
        }
    }

    onEventIsFreeChange(value: boolean): void {
        this.event.free = value;

        if (value) {
            this.event.standardUnitPrice = 0;
            this.event.backOfficeUnitPriceId = null;
        }
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }
}

@Component({
    selector: 'jhi-event-popup',
    template: ''
})
export class EventPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private eventPopupService: EventPopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            if (params['id']) {
                this.modalRef = this.eventPopupService
                    .open(EventDialogComponent as Component, params['id']);
            } else {
                this.modalRef = this.eventPopupService
                    .open(EventDialogComponent as Component);
            }

        });

    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/event/event-dialog.component.ts